export const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
export const uid = () => crypto.randomUUID();
export function timeLabel(value = 0, precise = false) {
  if (!Number.isFinite(value)) return '0:00';
  const seconds = Math.max(0, value);
  const h = Math.floor(seconds / 3600);
  const m = Math.floor(seconds / 60) % 60;
  const s = Math.floor(seconds % 60).toString().padStart(2, '0');
  return `${h ? `${h}:${String(m).padStart(2, '0')}` : m}:${s}${precise ? `.${Math.floor((seconds % 1) * 10)}` : ''}`;
}
export function escapeHTML(value = '') {
  return String(value).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}
export function emit(element, name, detail) {
  element.dispatchEvent(new CustomEvent(name, { detail, bubbles: true, composed: true }));
}
export function sortedBookmarks(bookmarks) { return [...bookmarks].sort((a, b) => a.time - b.time || a.number - b.number); }
export function previousBookmark(bookmarks, time) {
  return sortedBookmarks(bookmarks).filter(b => b.time <= time + 0.15).at(-1) ?? null;
}
export function nextBookmark(bookmarks, time) {
  return sortedBookmarks(bookmarks).find(b => b.time > time + 0.15) ?? null;
}
export const BOOKMARK_TOLERANCE = .5;
export function bookmarkAt(bookmarks, time) {
  return [...bookmarks].filter(b => Math.abs(b.time - time) <= BOOKMARK_TOLERANCE)
    .sort((a, b) => Math.abs(a.time - time) - Math.abs(b.time - time) || a.number - b.number)[0] ?? null;
}
export function adjacentBookmark(bookmarks, time, direction) {
  const position = bookmarkAt(bookmarks, time)?.time ?? time;
  const ordered = sortedBookmarks(bookmarks);
  return direction < 0 ? ordered.filter(b => b.time < position - .01).at(-1) ?? null
    : ordered.find(b => b.time > position + .01) ?? null;
}
export function parseTime(value) {
  const fields = String(value).trim().split(':');
  if (!fields.length || fields.length > 3 || fields.some(f => !/^\d+(\.\d+)?$/.test(f))) return NaN;
  return fields.reduce((total, part) => total * 60 + Number(part), 0);
}
